import { UserWithCompanyName } from '@rw1/auto-generated-clients/generated/user-management/dto.generated'
import { jwtDecode } from 'jwt-decode'
import * as Models from '@rw1/models'
import { injectable } from 'inversify'
import { IAuth0Mapper } from './IAuth0Mapper'



@injectable()
export class Auth0Mapper implements IAuth0Mapper {
    accessTokenToAuth0User(access_token: string, id_token: string): Models.IAuth0User {
        let auth_claims: Models.IOriginalAccessTokenClaims & Models.IOriginalIdTokenClaims

        try {
            auth_claims = {
                ...jwtDecode<Models.IOriginalAccessTokenClaims>(access_token),
                ...jwtDecode<Models.IOriginalIdTokenClaims>(id_token)
            }
        } catch (err) {
            throw new Error(`Error validating token claims: ${err}`)
        }

        const [language, country] = auth_claims[Models.ID_CLAIMS_KEYS.LOCALE].split('-')

        return {
            ...auth_claims,
            country: country ?? 'US',
            language: language ?? 'en',
            email: auth_claims[Models.ID_CLAIMS_KEYS.EMAIL],
            user_id: auth_claims[Models.ID_CLAIMS_KEYS.USER_ID],
            username: auth_claims[Models.ID_CLAIMS_KEYS.USERNAME],
            role: auth_claims[Models.ID_CLAIMS_KEYS.ROLE],
            forename: auth_claims[Models.ID_CLAIMS_KEYS.FORENAME],
            surname: auth_claims[Models.ID_CLAIMS_KEYS.SURNAME],
            job_title: auth_claims[Models.ID_CLAIMS_KEYS.JOB_TITLE],
            profile_picture: auth_claims[Models.ID_CLAIMS_KEYS.PROFILE_PICTURE_URL],
            userType: auth_claims[Models.ID_CLAIMS_KEYS.USER_TYPE],

            company_id: auth_claims[Models.ID_CLAIMS_KEYS.COMPANY_ID],
            company_name: auth_claims[Models.ID_CLAIMS_KEYS.COMPANY_NAME],
            sso_domains: auth_claims[Models.ID_CLAIMS_KEYS.SSO_DOMAINS] ?? '',
            name_id: auth_claims[Models.ID_CLAIMS_KEYS.NAME_ID],
        }
    }

    toUserWithCompanyName(userObject: Models.IAuth0User): UserWithCompanyName {
        return {
            emailAddress: userObject.email,
            userId: userObject.user_id,
            username: userObject.username,
            forename: userObject.forename,
            surname: userObject.surname,
            jobTitle: userObject.job_title,
            language: userObject.language,
            country: userObject.country,
            role: userObject.role,
            companyId: userObject.company_id,
            companyName: userObject.company_name,
            profilePictureUrl: userObject.profile_picture,
        } as UserWithCompanyName
    }

    fromUserWithCompanyName(userObject: UserWithCompanyName): Partial<Models.IAuth0User> {
        return {
            email: userObject.emailAddress,
            user_id: userObject.userId,
            forename: userObject.forename,
            surname: userObject.surname,
            language: userObject.language,
            country: userObject.country,
            role: userObject.role,
            company_id: userObject.companyId,
            company_name: userObject.companyName,
            ...(userObject.profilePictureUrl && { profile_picture: userObject.profilePictureUrl }),
            ...(userObject.jobTitle && { job_title: userObject.jobTitle }),
            ...(userObject.username && { username: userObject.username }),
        }
    }
}
